import { Pipe, PipeTransform } from '@angular/core';


interface ITcfCompaniesList {
  id: number;
  name: string;
  indeterminate: boolean;
  dsp_settings: ITcfEndpoint[];
  tcf: boolean;
  consent: boolean;
}

interface ITcfEndpoint {
  id: number;
  companyId: number;
  tcf: boolean;
  consent: boolean;
  active: number;
  name: string;
}

@Pipe({
  name: 'tcfCompaniesSearch',
  standalone: false
})
export class TcfCompaniesSearchPipe implements PipeTransform {

  transform(companies: ITcfCompaniesList[], searchValue: string): ITcfCompaniesList[] {
    if (!companies || !companies.length) {
      return companies;
    }

    if (!searchValue || searchValue.trim() === '') {
      return companies;
    }

    const searchLower = searchValue.toLowerCase().trim();

    const result: ITcfCompaniesList[] = [];

    for (const company of companies) {
      // Check if company id or name matches
      const companyMatches = company.id.toString().includes(searchLower) ||
        company.name.toLowerCase().includes(searchLower);

      // If company matches, return the whole company with all dsp_settings
      if (companyMatches) {
        result.push(company);
        continue;
      }

      // Filter dsp_settings that match the search
      const filteredDspSettings = company.dsp_settings?.filter(dspSetting => {
        return dspSetting.id.toString().includes(searchLower) ||
          dspSetting.name.toLowerCase().includes(searchLower);
      }) || [];

      // If there are matching dsp_settings, add company with filtered dsp_settings
      if (filteredDspSettings.length > 0) {
        result.push({
          ...company,
          dsp_settings: filteredDspSettings
        });
      }
    }

    return result;
  }

}
